import { ALERTS_FETCHED, FETCHING_ALERTS_FAILED } from '../../actions/actionTypes';

const initialState = {
    alerts: [],
    locationParams: null
};

const alertsNotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case ALERTS_FETCHED:
            return Object.assign({}, state, {
                alerts: action.alerts
            });

        case FETCHING_ALERTS_FAILED:
            return Object.assign({}, state, {
                alerts: []
            });

        default:
            return state;
    }
};

export default alertsNotificationReducer;
